<template>

    <el-col
      class="content"
      :xl="{ span: 18 }"
      :lg="{ span: 18 }"
      :md="{ span: 18 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <div class="mydoc">
        <div class="header" style="font-weight: 900">
          【实验语言学】期刊简介
        </div>
        <div class="mybody">
          <p>
            《实验语言学》刊物于2012年创刊，国际刊号（lSSN
            2186-3288）。实行双向匿名审稿。主要刊登以物理、生理、心理、以及脑科学的实验方法进行的普通语言学和专语语言学研究以及语言应用研究以及多语言比较研究等方面的论文，并开设专题研究探讨一些重要的语言学理论和方法问题。
          </p>
          <p>编辑部人员有五校联合组成：</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;名誉主编: 石锋(中国南开大学)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;联合主编: 时秀娟(中国山东大学)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;联合主编: 温宝莹(中国南开大学)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;副主编:彭刚(中国香港理工大学)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;副主编: 于秒(中国天津师范大学)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;副主编: 陈飞(中国湖南大学)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;发行人: 杨晓安(日本长崎大学)</p>

          <p>
            目前刊物为季刊，每年四期，3月、6月、9月和12月1日出版，网站会同时刊出文章电子版。
          </p>
          <p>刊物的网上投稿系统网址: http://www.exp-linguistics.com。</p>
          <p>
            设有公众号“实验语言学elinguistics”，对刊物进行推广，提供期刊往期和最新目录。定期推送已发表的重要论文和原创试刊论文。
          </p>
          <p>
            刊物设有
            “语言实验之星”评奖，每两年一次，鼓励青年学子走上语言研究科学化的道路，激发青年学子积极性、主动性、创造性。
          </p>
          <p>刊物由北京世界图书出版公司期刊部征订，刊号为: BWT03。</p>
          <p>期刊征订电话为：13520794499，征订邮箱qkb2@wpcbj.com.cn。</p>
        </div>
      </div>
    </el-col>


</template>>

<script>
import loginComponent from "@/components/loginComponent";

export default {
  name: "introduction",
  components: {
    loginComponent,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    // box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>


// WEBPACK FOOTER //
// src/view/introduction.vue